import React from 'react';

function InputField(props: {
    id: string;
    label: string;
    extra?: string;
    placeholder: string;
    variant?: string;
    state?: string;
    disabled?: boolean;
    type?: string;
    onChange?: any;
    defaultValue?: string;
    value?: string;
    required?: boolean;
    message?: string;
    description?: string;
    fieldsetStyle?: React.CSSProperties;
}) {
    const {
        label,
        id,
        extra,
        type,
        placeholder,
        variant,
        state,
        disabled,
        onChange,
        defaultValue,
        value,
        required,
        message,
        description,
        fieldsetStyle,
    } = props;

    if (variant === 'auth') {
        return (
            <div className={`${extra}`}>
                <label
                    htmlFor={id}
                    className="ml-0.5 font-geist text-xs font-medium text-leadrs-text-soft"
                >
                    {label}
                </label>
                <input
                    onChange={onChange}
                    disabled={disabled}
                    defaultValue={defaultValue}
                    value={value}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    className={`mt-1.5 h-11 w-full rounded-lg border bg-white px-3 font-geist text-sm text-leadrs-text outline-none transition-all duration-200 placeholder:text-leadrs-text-soft/60 ${
                        disabled
                            ? 'cursor-not-allowed border-leadrs-disabled-stroke bg-leadrs-disabled text-leadrs-text-soft'
                            : state === 'error'
                            ? 'border-leadrs-wrong/40 bg-leadrs-red-soft placeholder:text-leadrs-wrong/50 focus:border-leadrs-wrong focus:ring-2 focus:ring-leadrs-wrong/10'
                            : state === 'success'
                            ? 'border-leadrs-success/40 bg-leadrs-green-soft focus:border-leadrs-success focus:ring-2 focus:ring-leadrs-success/10'
                            : 'border-leadrs-stroke hover:border-leadrs-yellow-focus/30 focus:border-leadrs-yellow-focus focus:ring-2 focus:ring-leadrs-yellow-focus/10'
                    }`}
                />
            </div>
        );
    }

    // Disabled — flat gray box, no border, no floating label
    if (disabled) {
        return (
            <div className={extra ?? ''}>
                <div className="relative rounded-2xl bg-leadrs-disabled px-4 py-3">
                    <label htmlFor={id} className="sr-only">{label}</label>
                    <input
                        disabled
                        defaultValue={defaultValue}
                        value={value}
                        type={type}
                        id={id}
                        placeholder={placeholder}
                        className="w-full cursor-not-allowed bg-transparent font-geist text-sm font-semibold text-leadrs-text-soft outline-none placeholder:text-leadrs-text-soft/40"
                    />
                </div>
            </div>
        );
    }

    const isDefault = !state || state === 'default';

    const borderClass = isDefault
        ? 'border-gray-900'
        : state === 'success'
        ? 'border-leadrs-success'
        : state === 'info'
        ? 'border-leadrs-info'
        : 'border-leadrs-wrong';

    const legendClass = isDefault
        ? 'text-gray-900'
        : state === 'success'
        ? 'text-leadrs-success'
        : state === 'info'
        ? 'text-leadrs-info'
        : 'text-leadrs-wrong';

    const messageBg = state === 'success'
        ? 'bg-leadrs-green-soft text-leadrs-success'
        : state === 'info'
        ? 'bg-leadrs-yellow-soft text-leadrs-info'
        : state === 'error'
        ? 'bg-leadrs-red-soft text-leadrs-wrong'
        : '';

    const iconBg = state === 'success'
        ? 'bg-leadrs-success'
        : state === 'info'
        ? 'bg-leadrs-info'
        : 'bg-leadrs-wrong';

    return (
        <div className={extra ?? ''}>
            <fieldset className={`rounded-2xl border px-3 pt-0.5 pb-2 ${borderClass}`} style={fieldsetStyle}>
                <legend className={`ml-1.5 px-1 font-geist text-xs font-medium ${legendClass}`}>
                    {label}{required && <span className="text-red-500">*</span>}
                </legend>
                <input
                    onChange={onChange}
                    defaultValue={defaultValue}
                    value={value}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    className="w-full bg-transparent font-geist text-sm font-medium text-gray-500 outline-none placeholder:text-gray-400"
                />
            </fieldset>
            {message && messageBg && (
                <div className={`mt-2 flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-medium ${messageBg}`}>
                    <div className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[11px] font-bold leading-none text-white ${iconBg}`}>
                        !
                    </div>
                    <span>{message}</span>
                </div>
            )}
            {description && (
                <p className="mt-1.5 text-xs text-leadrs-text-soft">{description}</p>
            )}
        </div>
    );
}

export default InputField;
